import { Button } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import img from "../../assets/images/empty.png";
import MessagePanel from "../../components/messagePanel";
import RaksDrawer from "../../components/raksDrawer";
import { authActions } from "../../store/actions/auth.actions";
import { organizacjeActions } from "../../store/actions/organizacje.actions";
import { IDRaksStore } from "../../store/store";
import { AccountActionsState } from "../../store/types/auth";
import { OrganizacjaWidok } from "../../store/types/organizacje";
import { OrganizacjePageStyle } from "../../styles/OrganizacjaPageStyle";
import OrganizacjaElement from "./organizacja.element";
import OrganizacjeEdycja from "./organizacje.edycja";
import { uzytkownicyActions } from "../../store/actions/uzytkownicy.actions";
import useWybranaOrganizacja from "../../hooks/useWybranaOrganizacja";

interface OrganizacjePageProps {
  error: string;
  lista: OrganizacjaWidok[];
  accountActionsState: AccountActionsState;
  onPrzegladaj: Function;
  onUsun: Function;
  onClearAccountActionsState: Function;
  onClearAuthError: Function;
  onOpuscOrganizacje: Function;
  wybrana: OrganizacjaWidok;
}

const OrganizacjePage = (props: OrganizacjePageProps) => {
  const {
    error,
    onPrzegladaj,
    lista,
    onUsun,
    accountActionsState,
    onClearAccountActionsState,
    onClearAuthError,
    onOpuscOrganizacje,
    wybrana,
  } = props;

  const [isDrawer, setIsDrawer] = useState(false);
  const [edytowaneId, setEdytowaneId] = useState("");
  const [pobranoDane, setPobranoDane] = useState(false);
  const { wybierzPierwszaOrganizacje } = useWybranaOrganizacja();

  const odswiezListe = () => {
    onPrzegladaj().then(() => {
      setPobranoDane(true);
    });
  };

  const obsluzUsuniecie = (id: string) => {
    onPrzegladaj().then((lista: OrganizacjaWidok[]) => {
      if (wybrana.Id === id) wybierzPierwszaOrganizacje(lista);
    });
  };

  useEffect(() => {
    odswiezListe();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    return () => {
      onClearAuthError();
      onClearAccountActionsState();
    };
    // eslint-disable-next-line
  }, []);

  function usun(id: string) {
    onUsun(id).then(() => {
      obsluzUsuniecie(id);
    });
  }

  function edytuj(id: string) {
    setEdytowaneId(id);
    setIsDrawer(true);
  }

  function opuscOrganizacje(id: string, idZaproszenia: string) {
    onOpuscOrganizacje(id, idZaproszenia).then(() => {
      obsluzUsuniecie(id);
    });
  }

  return (
    <OrganizacjePageStyle>
      <header>
        <h5>Twoje Organizacje</h5>
        <Button
          name="btnZapisz"
          color="secondary"
          variant="contained"
          onClick={() => {
            setEdytowaneId("");
            setIsDrawer(true);
          }}
        >
          NOWA ORGANIZACJA
        </Button>
      </header>
      {error ? (
        <MessagePanel title="Błąd" mode="error" message={error} />
      ) : accountActionsState === AccountActionsState.ConfirmEmailSuccess ? (
        <MessagePanel
          title="Sukces"
          mode="success"
          message="Dziękujemy za potwierdzenie konta."
        />
      ) : (
        <div />
      )}
      {lista.length > 0 ? (
        <section>
          {lista.map((o, i) => (
            <OrganizacjaElement
              key={i}
              element={o}
              onEdit={() => edytuj(o.Id)}
              onDelete={() => usun(o.Id)}
              onOpusc={() => opuscOrganizacje(o.Id, o.IdZaproszenia)}
            />
          ))}
        </section>
      ) : pobranoDane ? (
        <div className="empty">
          <img src={img} alt="logo" />
          <h4>Nie masz jeszcze żadnych Organizacji</h4>
        </div>
      ) : (
        <div />
      )}
      <RaksDrawer
        isOpen={isDrawer}
        onCancel={() => setIsDrawer(false)}
        withExitEvent
      >
        <OrganizacjeEdycja onSaveAction={odswiezListe} editId={edytowaneId} />
      </RaksDrawer>
    </OrganizacjePageStyle>
  );
};

function mapStateToProps(store: IDRaksStore) {
  return {
    error: store.organizacje.browseError,
    lista: store.organizacje.lista,
    accountActionsState: store.auth.accountActionsState,
    wybrana: store.organizacje.wybrana,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onPrzegladaj: () => dispatch(organizacjeActions.przegladaj()),
    onUsun: (id: string) => dispatch(organizacjeActions.usun(id)),
    onClearAuthError: () => {
      dispatch(authActions.clearError());
    },
    onClearAccountActionsState: () => {
      dispatch(authActions.clearAccountActionsState());
    },
    onOpuscOrganizacje: (idOrg: string, idZaproszenia: string) =>
      dispatch(uzytkownicyActions.usun(idOrg, idZaproszenia)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(OrganizacjePage);
